import Qs from 'query-string'
class ShareUtil {
  #shared = '' // 分享短码
  #menus = new Set() // 控制菜单

  constructor () {
    this.#shared = Qs.parseUrl(window.location.href).query.share
    this.#menus = new Set((sessionStorage.getItem(`SHARE-MENUS-${this.#shared}`) || '').split(','))
  }

  show (button) {
    return this.#menus.has(button)
  }
}
export default ShareUtil
